<template>
  <div class="board-item" @click.stop="router.push(`/field/board/${gallery._id}`)">

    <img v-if="previewImage && !isVideo" :src="previewImage">
    <video autoplay playsinline muted loop v-else :src="previewImage"></video>
    <span class="board-title">{{ gallery.title }}</span>
    <div class="flex flex-1 justify-end">
      <RoundedIcon
          ref="roundedIcon"
          :class="isAdded ? 'selected' : ''"
          :src="iconSrc"
          @click.stop="highlight(work)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineEmits, defineProps, onMounted, ref, watch } from 'vue';
import RoundedIcon from '~/components/RoundedIcon.vue';
import axios from "axios";
const router = useRouter();

const props = defineProps({
  gallery: {
    type: Object,
    default: () => ({
      coverImage: '',
      title: '',
      tag: '',
      works: [],
      users: [],
      user: null
    })
  },
  work: {
    type: Object
  },
  isAdded: Boolean,
});
const isVideo = ref(false);
onMounted(async () => {
  const res = coverImage.value;
  if (res.includes('vimeo')) {
    const result = await fetchVideo(res);
    console.log('fv', result);
    if (!result) {
      previewImage.value = '/icons/profile_placeholder.png';
    } else {
      previewImage.value = result;
    }
  } else {
    if (res) {

      if (res.includes('.mp4')) {
        isVideo.value = true;
      } else {
        isVideo.value = false;
      }
      previewImage.value = res;
    } else {
      previewImage.value = '/icons/profile_placeholder.png';
    }
  }
})

const getVimeoVideoId = (url: any) => {
  const regex = /(?:vimeo\.com|vimeocdn\.com)\/(?:.*#|.*\/videos\/)?([0-9]+)(?:$|\/|\?)/;
  const match = url.match(regex);
  return match ? match[1] : null;
};

const fetchVideo = async (url: any) => {
  try {

    const videoId = getVimeoVideoId(url);
    console.log('videoId', videoId, url);
    if (!videoId) {
      return;
    }

    const response = await axios.get(`https://api.vimeo.com/videos/${videoId}`, {
      headers: {
        Authorization: `Bearer 2882f8d876e951dfb0357c88629dcf78` // Replace with your Vimeo access token
      }
    });
    return response.data.pictures.sizes[3].link;
    //toast.success('Video details fetched successfully');
  } catch (error) {
    console.error('Vimeo API error:', error);
    return false;
  }
};
const coverImage = computed(() => {
  const gallery = props.gallery;
  let res = '';

  console.log('gal cov', gallery.coverImage);

  // Sort works by 'created' field and get the latest work's cover image
  const latestWork = gallery.works
      .filter(work => work.work && work.work.coverImage)[gallery.works
      .filter(work => work.work && work.work.coverImage).length - 1];

  if (latestWork) {
    res = latestWork.work.coverImage;
    return res;
  }

  // Use coverImage from users if available (only if no work cover image)
  const userWithCoverImage = gallery.users.find(user => user && user.coverImage);
  if (userWithCoverImage) {
    res = userWithCoverImage.coverImage;
    return res;
  }

  // Use coverImage from reads if available (only if no work or user cover image)
  if (gallery.reads && gallery.reads.length > 0) {
    res = gallery.reads[0].coverImage;
    return res;
  }

  // Fallback to a placeholder if no valid cover image is found
  return '/icons/profile_placeholder.png';
});

watch(coverImage, async () => {
  const res = coverImage.value;
  if (res.includes('vimeo') && !res.includes('cdn')) {
    const result = await fetchVideo(res);
    console.log('fv', result);
    if (!result) {
      previewImage.value = '/icons/profile_placeholder.png';
    } else {
      previewImage.value = result;
    }
  } else {
    if (res) {
      previewImage.value = res;
    } else {
      previewImage.value = '/icons/profile_placeholder.png';
    }
  }
})
const emits = defineEmits(['highlight', 'deleteGallery']);

const highlight = (work: any) => {
  emits('highlight', props.gallery, work);
}

const deleteGallery = () => {
  emits('deleteGallery', props.gallery)
}

const iconSrc = ref('/icons/plus_black.png');
const previewImage = ref<any>(null);

const handleDoubleClick = () => {
  deleteGallery();
}
</script>

<style scoped>
.board-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 13px;
}
.board-title {
  color: black;
  font-size: 16px;
}
.board-item img {
  width: 64px;
  aspect-ratio: 1;
  object-fit: cover;
  background: #ededed;
  border-radius: 10px;
}
.board-item video {
  width: 64px;
  aspect-ratio: 1;
  object-fit: cover;
  background: #ededed;
  border-radius: 10px;
}
.selected {
  background: #E3FF00;
  border: unset;
}
.rotate {
  transition: transform 0.5s;
  transform: rotate(360deg);
}
</style>
